import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Grid,
  Typography,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Export } from '@styled-icons/boxicons-regular';
import {
  FilterSync,
  FilterDismiss,
} from '@styled-icons/fluentui-system-filled';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DatePicker from 'components/Fields/DatePicker';
import SearchField from 'components/Fields/SearchField';
import MultipleSelect from 'components/Fields/MultipleSelect';
import { MODAL_TYPES } from 'config';
import { setModal } from 'redux/slices/modalSlice';
import { clearFilters, applyFilters, getData, unSetDownloadLink } from 'redux/slices/dataSlice';
import { filteredData } from './filters';
import {
  filterByNameSelector,
  filterByLastNameSelector,
  filterByDocumentSelector,
  filterByBatchSelector,
  filterByOperationStatusSelector,
  filterByOperationDateSelector,
  filterByOperationTypesSelector,
  loadingStatus,
  downloadLinks
} from 'redux/selectors';
import DownloadLoading from 'components/Loading/DownloadLoading';

const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
`;


const ExportIcon = styled(Export)`
  width: 1.8rem;
  height: 1.8rem;
  color: green;
`;


const ClearFiltersIcon = styled(FilterDismiss)`
  width: 1.8rem;
  height: 1.8rem;
  color: red;
`;
const SyncFiltersIcon = styled(FilterSync)`
  width: 1.8rem;
  height: 1.8rem;
  color: blue;
`;

const VerticalDivider = styled.div`
  border-left: 3px solid gray;
  height: 1.5rem;
`;

function Header() {
  const dispatch = useDispatch();
  const filterByName = useSelector(filterByNameSelector);
  const filterByLastName = useSelector(filterByLastNameSelector);
  const filterByDocument = useSelector(filterByDocumentSelector);
  const filterByBatch = useSelector(filterByBatchSelector);
  const filterStatus = useSelector(filterByOperationStatusSelector);
  const filterTypes = useSelector(filterByOperationTypesSelector);
  const filterDate = useSelector(filterByOperationDateSelector);
  const loading = useSelector(loadingStatus);
  const successLinks = useSelector(downloadLinks);

  const handleExportFile = () => {
    dispatch(setModal({ type: MODAL_TYPES.exportFileModal, }));
  };

  const handleGenerateLinks = () => {
    dispatch(setModal({ type: MODAL_TYPES.exportLinksModal, }));
  };


  const handleBulkAdd = () => {
    dispatch(
      setModal({
        display: true,
        type: MODAL_TYPES.bulkAddModal,
      })
    );
  };


  const handleApplyFilters = () => {
    const dataFilter = filteredData(
      filterStatus,
      filterDate,
      filterByName,
      filterByLastName,
      filterByDocument,
      filterByBatch,
      filterTypes
    );
    const filterQuery = dataFilter.filters ? dataFilter : {};
    dispatch(getData(filterQuery))
    dispatch(applyFilters())
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="space-between"
      alignItems="stretch"
    >
      <Grid >
        <HeaderContainer p={1}>
          <Typography variant="h5" gutterBottom>
            Listado de operaciones
          </Typography>
        </HeaderContainer>
      </Grid>
      <Grid
        item
        container
        spacing={2}
        direction="row"
        justifyContent="space-around"
        alignItems="center"
      >
        <Grid
          direction="column"
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MultipleSelect />
            <DatePicker />
          </Grid>
          <Grid>
            <SearchField />
          </Grid>
        </Grid>

        <Grid item>
          <Tooltip title="Aplicar filtros">
            <IconButton onClick={handleApplyFilters}>
              <SyncFiltersIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title="Borrar filtros">
            <IconButton onClick={handleClearFilters}>
              <ClearFiltersIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          <VerticalDivider />
        </Grid>
        <Grid item direction="column" justifyContent="center" alignItems="center" >
          {loading.createLinks && <DownloadLoading message='Generando Links' />}
          {successLinks.createLinks &&
            <div>
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                href={successLinks.createLinks}
                onClick={() => dispatch(unSetDownloadLink('createLinks'))}
              >
                Descargar
                <ArrowDownwardIcon fontSize="inherit" />
              </Button>
            </div>
          }
          {(!loading.createLinks && !successLinks.createLinks) &&
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleGenerateLinks}
            >
              Exportar Links
            </Button>
          }
        </Grid>
        <Grid item direction="column" justifyContent="center" alignItems="center">
          {loading.uploadBulk ? <DownloadLoading message='Cargando Operaciones' /> :
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleBulkAdd}
            >
              Alta masiva
            </Button>
          }
        </Grid>
        <Grid item>
          {loading.exportFile && <DownloadLoading message='Exportando archivo' />}
          {successLinks.exportFile &&
            <div>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                href={successLinks.exportFile}
                onClick={() => dispatch(unSetDownloadLink('exportFile'))}
              >
                Descargar
                <ArrowDownwardIcon fontSize="inherit" />
              </Button>
            </div>
          }
          {(!loading.exportFile && !successLinks.exportFile) &&
            <Tooltip title="Exportar archivo operaciones filtradas">
              <IconButton onClick={handleExportFile}>
                <ExportIcon />
              </IconButton>
            </Tooltip>
          }
        </Grid>
      </Grid>
    </Grid >
  );
}

export default Header;
